import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { ArrowRight, ChevronDown } from 'lucide-react';

const HeroSection = ({ scrollToContact }) => {
  const { t } = useLanguage();

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
      data-testid="hero-section"
    >
      {/* Background Image - Abstract tech pattern */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1762281429312-77566d0ad182?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGRhcmslMjB0ZWNobm9sb2d5JTIwZGF0YSUyMGFuYWx5dGljc3xlbnwwfHx8fDE3NzU0NzU5NjV8MA&ixlib=rb-4.1.0&q=85')`
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 hero-overlay" />
      
      {/* Decorative elements */}
      <div className="absolute top-1/4 left-10 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-10 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center">
        <div className="animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass mb-8">
            <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse" />
            <span className="text-sm text-white/80">B2B Gaming & Betting Solutions</span>
          </div>
        </div>

        <h1 
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 animate-fade-in-up delay-100"
          data-testid="hero-title"
        >
          {t(translations.hero.title)}
        </h1>
        
        <p 
          className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-10 animate-fade-in-up delay-200"
          data-testid="hero-subtitle"
        >
          {t(translations.hero.subtitle)}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up delay-300">
          <button
            onClick={() => scrollToContact()}
            className="btn-primary flex items-center gap-2 text-base"
            data-testid="hero-cta-button"
          >
            {t(translations.hero.cta)}
            <ArrowRight className="w-5 h-5" />
          </button>
          
          <a
            href="#services"
            className="btn-secondary flex items-center gap-2 text-base"
            data-testid="hero-learn-more"
          >
            {t(translations.hero.ctaSecondary)}
          </a>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
          <a href="#services" className="text-white/50 hover:text-white/80 transition-colors">
            <ChevronDown className="w-8 h-8" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
